module.exports = __webpack_public_path__ + "img/Ma.Maritime.Quaywalls.Gravitywall-10m.Concrete.2b853f45.png";